export default {
    
    "afterAddingToCart":"3",
    "autofill":"yes",
    "autofillQuantity":"5",
    "defaultRegistration":"company",
    "redirectCustomer":"no",
    "googleMapsKey":"",
    "erpOrdersAvailability":"yes",
    "invoicesAvailability":"yes",
    "SORAvailability":"yes",
    "WMAvailability":"no",
    "POOType":"map",
    "autoLanguage":"no",
    "allowCheckingAvailabilityInShop":"no",
    "checkAvailabilityInShopPresentation":"words",
    "scheduledDeliveryDateEditable":"yes",
    "deliveryDateType":"date",
    "editDataFromGUS":"no",
    "editDataFromNotRespondingGUS":"no",
    "editDataFromVIES":"no",
    "showProductGuardian":"yes",
    "showGuardianNameAs":"name-and-surname",
    "showGuardianPhoneNo":"yes",
    "blockCompanyDataEdition":"no",
    "blockCompanyDataEditionFor":"everybody",
    "blockAddingAndEditingDeliveryAddress":"no",
    "blockAddingAndEditingDeliveryAddressFor":"everybody",
    "blockAddingEmployees":"no",
    "blockAddingEmployeesFor":"everybody",
    "discountsPresentationOnOrderPositions":"yes",
    "discountsPresentationInOrderSummary":"yes",
    "showUnitRateOnProductDetailsPage":"yes",
    "showUnitRateOnProductDetailsPageUnit":"default",
    "showUnitRateOnCartPage":"yes",
    "previousPriceAsSuggestedRetailPrice":"no",
    "lowestProductPrice":"yes",
    "onlySubtotalPrice":"no",
    "notAuthStock":"yes",
    "compareProducts":"yes",
    "downloadsAvailability":"yes",
    "buyerData":"no",
    "loyaltyProgram":"yes",
    "inquiries":"yes",
    "technicalBreak":"no",
    "deligoo":"no",
    "productsDeliveries":"no",
    "notAuthenticatedCartImport":"on",
    "notAuthenticatedCartImportNo":"4",
    "notAuthenticatedCartImportIcon":"ti-import",
    "notAuthenticatedCartImportLabel":"Import koszyka",
    "notAuthenticatedCartImportTranslation":"CartImport",
    "notAuthenticatedDownloadCSV":"on",
    "notAuthenticatedDownloadCSVNo":"5",
    "notAuthenticatedDownloadCSVIcon":"ti-download",
    "notAuthenticatedDownloadCSVLabel":"Pobierz przykładowy plik CSV",
    "notAuthenticatedDownloadCSVTranslation":"DownloadCSV",
    "notAuthenticatedManufacturers":"on",
    "notAuthenticatedManufacturersNo":"1",
    "notAuthenticatedManufacturersIcon":"ti-shield",
    "notAuthenticatedManufacturersLabel":"Producenci",
    "notAuthenticatedManufacturersTranslation":"Manufacturers",
    "notAuthenticatedManufacturersLink":"producenci,20",
    "notAuthenticatedLookbookNo":"2",
    "notAuthenticatedLookbookIcon":"ti-layout-slider-alt",
    "notAuthenticatedLookbookLabel":"Lookbook",
    "notAuthenticatedLookbookTranslation":"Lookbook",
    "notAuthenticatedLookbookLink":"lookbook,26",
    "notAuthenticatedSearchAdvanced":"on",
    "notAuthenticatedSearchAdvancedNo":"3",
    "notAuthenticatedSearchAdvancedIcon":"ti-target",
    "notAuthenticatedSearchAdvancedLabel":"Wyszukiwarka zaawansowana",
    "notAuthenticatedSearchAdvancedTranslation":"SearchAdvanced",
    "notAuthenticatedSearchAdvancedLink":"wyszukiwarka-zaawansowana,18",
    "customer-links":"0",
    "authenticatedCartImport":"on",
    "authenticatedCartImportNo":"6",
    "authenticatedCartImportIcon":"ti-import",
    "authenticatedCartImportLabel":"Import koszyka",
    "authenticatedCartImportTranslation":"CartImport",
    "authenticatedDownloadCSV":"on",
    "authenticatedDownloadCSVNo":"7",
    "authenticatedDownloadCSVIcon":"ti-download",
    "authenticatedDownloadCSVLabel":"Pobierz przykładowy plik CSV",
    "authenticatedDownloadCSVTranslation":"DownloadCSV",
    "promotions":"on",
    "promotionsNo":"1",
    "promotionsIcon":"ti-money",
    "promotionsLabel":"Promocje i kupony",
    "promotionsTranslation":"PromotionsAndCoupons",
    "promotionsLink":"profil-klienta,6?tab=discounts",
    "documents":"on",
    "documentsNo":"2",
    "documentsIcon":"ti-files",
    "documentsLabel":"Dokumenty",
    "documentsTranslation":"Documents",
    "documentsLink":"profil-klienta,6?tab=orders",
    "authenticatedManufacturers":"on",
    "authenticatedManufacturersNo":"3",
    "authenticatedManufacturersIcon":"ti-shield",
    "authenticatedManufacturersLabel":"Producenci",
    "authenticatedManufacturersTranslation":"Manufacturers",
    "authenticatedManufacturersLink":"producenci,20",
    "authenticatedLookbookNo":"4",
    "authenticatedLookbookIcon":"ti-layout-slider-alt",
    "authenticatedLookbookLabel":"Lookbook",
    "authenticatedLookbookTranslation":"Lookbook",
    "authenticatedLookbookLink":"lookbook,26",
    "authenticatedSearchAdvanced":"on",
    "authenticatedSearchAdvancedNo":"5",
    "authenticatedSearchAdvancedIcon":"ti-target",
    "authenticatedSearchAdvancedLabel":"Wyszukiwarka zaawansowana",
    "authenticatedSearchAdvancedTranslation":"SearchAdvanced",
    "authenticatedSearchAdvancedLink":"wyszukiwarka-zaawansowana,18",
    "animationType":"slide",
    "mainBannerAutoplaySpeed":"",
    "newsSectionAnimationOnHover":"yes",
    "manufacturersSliderAnimationOnHover":"yes",
    "manufacturersSliderAutoplaySpeed":"5000",
    "manufacturersSliderAutoplayToggle": "yes",
    "brandsSliderAnimationOnHover":"yes",
    "brandsSliderAutoplaySpeed":"5000",
    "brandsSliderAutoplayToggle": "yes",
    "newsAnimationOnHover":"yes",
    "infographicBannerAutoplaySpeed":"5000",
    "infographicBannerAutoplayToggle":"yes",
    "mainBannerSliderAutoplaySpeed": "5000",
    "mainBannerSlideAutoplayToggle": "yes",
    "discountsPresentation":"no",
    "couponsPresentation":"no",
    "showCouponsOnProductsLists":"no",
    "showCouponsOnProductsDetails":"no",
    "showCouponsInCart":"no",
    "bodyPromotionalBannerSet": "off",
    "bodyPromotionalBannerNo": 0,
    "blogPresentationOnHomepage":"extended",
    "maxfilter":"5",
    "toggleFilters":"2",
    "nameGraphDescCategory":"up",
    "categoryOpenedClosed":"closed",
    "selectedViewName":"quick-shopping",
    "graphicColorFilter":"no",
    "showShortDesc":"no",
    "showAttributesOnProductsPage":"yes",
    "attributesQuantityOnQuickView":"3",
    "attributesQuantityOnListView":"3",
    "allowAddingToCartMultiVariantProductsOnProductsList":"yes",
    "graphMenu":"no",
    "fontFamily":"Inter",
    "cartIconStyle":"shopping-cart",
    "spinnerIconStyle":"spinner-third",
    "iconStyle":"regular",
    "productPurchaseHistory":"no",
	"shareProducts":"share-yes",
    "share-fb":"share-fb-yes",
    "share-twt":"share-twt-yes",
    "share-wa":"share-wa-yes",
    "share-lin":"share-lin-no",
    "share-copy":"share-copy-yes",
    "share-mail":"share-mail-yes",
    "share-gmail":"share-gmail-no",
    "share-rec":"share-rec-yes",
	"share-pin":"share-pin-no",
	"showRotateImageOnList": "showRotateImageOnList-yes",
	"recipeForCompanyInCart":"yes",
	"signIn":"page",
	"printBtnShowHide":"printBtnShowHide-yes",
	"productIsInCart": "productIsInCart-no",
    "headerERPCategoriesOrder": "no",
    "minimalPrice" : "minimalPriceYes",
    "sizeChart" : "no",
    "sizeChartSiteID" : "27",
    "variantsOfSizeChart": "sizeChart-banner",
	"thresholds": "no",
	"google_translate":"google_translate-no",
	"logo_trusted_shop":"logo_trusted_shop-no",
	"logo_trusted_shopID":"",
    "logo_trusted_shopUrlID":"",
	"logo_trusted_desktopPosition":"right",
	"logo_trusted_mobilePosition":"right",
	"logo_trusted_mobileYOffset":"0",
	"logo_trusted_desktopYOffset":"0",
	"logo_trusted_disableReviews":"false",
	"logo_trusted_colorScheme":"light",
	"logo_trusted_desktop-enable-fadeout":"false", 
	"logo_trusted_mobile-enable-fadeout":"false", 
	"logo_trusted_data-disable-mobile":"false", 
	"logo_trusted_mobile-enable-topbar":"false",
	"logo_trusted_MainPage":"showMainPage",
	"logo_trusted_ProductsList":"",
	"logo_trusted_ProductDetails":"",
	"logo_trusted_Cart":"",

	"logo_trusted_shopYOffset":"60",
	"logo_trusted_shopVariant":"reviews",
    "widgetPosition" : "rightBottom",
	"CPSections":[{"name":"orders","available":true,"order":"1","icon":"clipboard-list","label":"Zamówienia","translation":"Orders","highlight":false,"dataTemplate":"partials/customer-profile/orders/orders.html"},{"name":"inquiries","available":true,"order":"2","icon":"file-invoice-dollar","label":"Zapytania o wycenę","translation":"Inquiries","highlight":false,"dataTemplate":"partials/customer-profile/inquiries/inquiries.html"},{"name":"offers","available":true,"order":"3","icon":"file-alt","label":"Oferty sprzedaży","translation":"Offers","highlight":false,"dataTemplate":"partials/customer-profile/offers/offers.html"},{"name":"invoices","available":true,"order":"4","icon":"file-invoice","label":"Faktury","translation":"Invoices","highlight":false,"dataTemplate":"partials/customer-profile/invoices/invoices.html"},{"name":"sor","available":true,"order":"5","icon":"file-spreadsheet","label":"Wydania zewnętrzne","translation":"SOR","highlight":false,"dataTemplate":"partials/customer-profile/sor/sor.html"},{"name":"wm","available":true,"order":"6","icon":"file-spreadsheet","label":"Wydania magazynowe","translation":"WM","highlight":false,"dataTemplate":"partials/customer-profile/wm/wm.html"},{"name":"complaints","available":true,"order":"7","icon":"file-edit","label":"Reklamacje/Zwroty","translation":"ComplaintsReturns","highlight":false,"dataTemplate":"partials/customer-profile/complaints/complaints.html"},{"name":"customerDetails","available":true,"order":"8","icon":"address-card","label":"Moje dane","translation":"MyData","highlight":false,"dataTemplate":"partials/customer-profile/customer-details/customer-details.html"},{"name":"employees","available":true,"order":"9","icon":"users","label":"Pracownicy","translation":"Employees","highlight":false,"dataTemplate":"partials/customer-profile/employees-list/employees-list.html"},{"name":"yourAccount","available":true,"order":"10","icon":"user","label":"Twoje konto","translation":"YourAccount","highlight":false,"dataTemplate":"partials/customer-profile/your-account/your-account.html"},{"name":"loyaltyProgram","available":true,"order":"11","icon":"award","label":"Program lojalnościowy","translation":"LoyaltyProgram","highlight":false,"dataTemplate":"partials/customer-profile/loyalty-list/loyalty-list.html"},{"name":"agreements","available":true,"order":"12","icon":"clipboard-check","label":"Zgody","translation":"Agreements","highlight":false,"dataTemplate":"partials/customer-profile/consents/consents.html"},{"name":"downloads","available":true,"order":"13","icon":"file-upload","label":"Do pobrania","translation":"Downloads","highlight":false,"dataTemplate":"partials/customer-profile/to-download/to-download.html"},{"name":"promotions","available":true,"order":"14","icon":"percent","label":"Promocje i kupony","translation":"PromotionsAndCoupons","highlight":false,"dataTemplate":"partials/customer-profile/discounts/discounts.html"}],
	"popupBannerDays": 31,
    "recommendedAIInCart":"yes",
	"filterOption":"filterOption-yes",
    "showAvailabilityStatus":"yes",

    "productListFilters__Manufacturer": "Manufacturer_Yes",
    "productListFilters__Brand": "Brand_Yes",
    "productListFilters__Availability": "Availability_Yes",
    "productListFilters__Rate": "Rate_Yes",
    "productListFilters__Photos": "Photos_Yes",
    "productListFilters__Attributes": "Attributes_Yes",
    "productListFilters__Flags": "Flags_Yes",

    "productDetailsManufacturer": "productDetailsManufacturer-yes",
    "productDetailsResponsiblePerson": "productDetailsResponsiblePerson-yes",
    "productDetailsBrand": "productDetailsBrand-yes",

    "eanCodes": "eanCodes-no",
    
    "grapicalVariantsPresentation": "Variants_No",
    "variantsGroupingAttribute": "Grouping_First",
    "grapicalVariantsPresentationColorsPL": "B\u0142\u0119kitny||#99CCFF|||Czerwony||#FF3300|||Niebieski||#3366FF|||Br\u0105zowy||#964b00|||Czarny||#000000|||Bia\u0142y||#FFFFFF|||Z\u0142oty||#ffd700|||R\u00f3\u017cowy||#ffc0cb|||Turkusowy||#76D7C4|||Pomara\u0144czowy||#fc9303|||Zielony||#008000|||Be\u017cowy||#c2b280|||Bordowy||#800000|||Ciemny szary||#909090|||Fioletowy||#87599d|||Granatowy||#000080|||Szary||#b4b4b4|||Zgni\u0142o zielony||#a5a542|||\u017b\u00f3\u0142ty||#ffef00|||Wielokolorowy||multicolor",
    "grapicalVariantsPresentationColorsEN": "Azure||#99CCFF|||Red||#FF3300|||Blue||#3366FF|||Brown||#964b00|||Black||#000000|||White||#FFFFFF|||Gold||#ffd700|||Pink||#ffc0cb|||Turquoise||#76D7C4|||Orange||#fc9303|||Green||#008000|||Beige||#c2b280|||Burgundy||#800000|||Dark grey||#909090|||Purple||#87599d|||Navy blue||#000080|||Gray||#b4b4b4|||Rotten green||#a5a542|||Yellow||#ffef00|||Multicolor||multicolor",
    "grapicalVariantsPresentationColorsDE": "Azurblau||#99CCFF|||Rot||#FF3300|||Blau||#3366FF|||Braun||#964b00|||Schwarz||#000000|||Wei\u00df||#FFFFFF|||Gold||#ffd700|||Rosa||#ffc0cb|||T\u00fcrkis||#76D7C4|||Orange||#fc9303|||Gr\u00fcn||#008000|||Beige||#c2b280|||Kastanienbraun||#800000|||Dunkelgrau\u00e9||#909090|||Violett||#87599d|||Marineblau||#000080|||Grau||#b4b4b4|||Fauliges Gr\u00fcn||#a5a542|||Gelb||#ffef00|||Mehrfarbig||multicolor",
    "grapicalVariantsPresentationColorsFR": "Azur||#99CCFF|||Rouge||#FF3300|||Bleu||#3366FF|||Marron||#964b00|||Noir||#000000|||Blanc||#FFFFFF|||Or||#ffd700|||Rose||#ffc0cb|||Turquoise||#76D7C4|||Orange||#fc9303|||Vert||#008000|||Beige||#c2b280|||Bordeaux||#800000|||Gris fonc\u00e9||#909090|||Violet||#87599d|||Bleu marine||#000080|||Gris||#b4b4b4|||Vert pourri||#a5a542|||Jaune||#ffef00|||Multicolore||multicolor",
}